import { AccountHardHatOutlineIcon } from './AccountHardHatOutlineIcon';

/**
 * author: Contributors
 * id 5A21DE4E-D502-4D12-8B2A-58FB95BE0964
 * name account-hard-hat-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-hard-hat-outline.svg
 * tags
 * - Account / User 
 */
export const ConstructionOutlineIcon = AccountHardHatOutlineIcon;
export default ConstructionOutlineIcon